module.exports = __webpack_public_path__ + "img/oneid-2.c03a39a1.png";